module.exports = __webpack_public_path__ + "static/img/6.fe41041.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/6.png
// module id = tfnG
// module chunks = 0